// src/api/revi/therapistApi.js
import { ENV } from "../../Utils/constants";
import { cabecerasApi } from "./cabeceras";

export class TherapistReviApi {
  constructor() {
    this.baseApi = ENV.BASE_API;
    this.routes = ENV.API_ROUTES;
  }

  async getByInstitution(token, institutionId, { page = 1, limit = 10 } = {}) {
    const url =
      `${this.baseApi}/${this.routes.THERAPIST_REVI}` +
      `/get/${institutionId}?page=${page}&limit=${limit}`;

    const response = await fetch(url, {
      headers: cabecerasApi(token),
    });

    const json = await response.json();
    if (response.status !== 200) throw new Error(json.message);
    return json; // { therapists, pagination, ... }
  }

  /**
   * Devuelve detalle enriquecido: { therapist, user }
   * Backend: GET /therapistreviprofile/get/:therapistId
   * Nota: en este proyecto se concatena como `${THERAPIST_REVI}profile/get/...`
   */
  async getById(token, therapistId) {
    const url = `${this.baseApi}/${this.routes.THERAPIST_REVI}profile/get/${therapistId}`;

    const response = await fetch(url, {
      method: "GET",
      headers: { ...cabecerasApi(token), "Content-Type": "application/json" },
    });

    const json = await response.json();
    if (response.status !== 200) {
      throw new Error(
        json.message || "Error al obtener el perfil del terapeuta",
      );
    }

    return json; // { code, message, therapist, user }
  }

  async create(token, institutionId, data) {
    const url = `${this.baseApi}/${this.routes.THERAPIST_REVI}/create/${institutionId}`;

    const response = await fetch(url, {
      method: "POST",
      headers: cabecerasApi(token),
      body: data,
    });

    const json = await response.json();
    if (response.status !== 200 && response.status !== 201) {
      throw new Error(json.message);
    }

    return json;
  }

  async update(token, therapistId, data) {
    const url = `${this.baseApi}/${this.routes.THERAPIST_REVI}/${therapistId}`;

    const response = await fetch(url, {
      method: "PATCH",
      headers: cabecerasApi(token),
      body: data,
    });

    const json = await response.json();
    if (response.status !== 200) throw new Error(json.message);

    return json;
  }

  async unlinkPatient(token, therapistId, patientId) {
    const url = `${this.baseApi}/${this.routes.THERAPIST_REVI}/unlink/${therapistId}`;

    const response = await fetch(url, {
      method: "PATCH",
      headers: { ...cabecerasApi(token), "Content-Type": "application/json" },
      body: JSON.stringify({ patientId }),
    });

    const json = await response.json();
    if (response.status !== 200) throw new Error(json.message);

    return json;
  }

  async delete(token, therapistId) {
    const url = `${this.baseApi}/${this.routes.THERAPIST_REVI}/${therapistId}`;

    const response = await fetch(url, {
      method: "DELETE",
      headers: cabecerasApi(token),
    });

    const json = await response.json();
    if (response.status !== 200) throw new Error(json.message);

    return json;
  }
}
